import { CustomerChatMessageTicketDataDto } from '@orcar/common';
import dayjs from 'dayjs';
import QRCode from 'react-qr-code';
import Divider from '@/assets/divider.svg';
import SureLogo from '@/assets/sure_logo.svg';
import { cn } from '@/utils/cn';

const ReservationTicket = ({
  data,
  time,
  isSure,
}: {
  data: CustomerChatMessageTicketDataDto;
  time: string;
  isSure?: boolean;
}) => {
  const {
    companyName,
    reservationId,
    pickUpAt,
    dropOffAt,
    vehicleModelName,
    sureDeepLinkUrl,
  } = data;

  const Dday = dayjs(pickUpAt).diff(dayjs(), 'day');
  const pickUpDate = dayjs(pickUpAt).format('YYYY-MM-DD');
  const pickUpTime = dayjs(pickUpAt).format('HH:mm');
  const dropOffDate = dayjs(dropOffAt).format('YYYY-MM-DD');
  const dropOffTime = dayjs(dropOffAt).format('HH:mm');

  return (
    <div className='flex items-end gap-1'>
      <div
        className={cn(
          'flex w-[635px] rounded-s bg-grey-000',
          isSure && 'h-[180px] w-[358px] max-w-[calc(100vw-60px)]',
        )}
      >
        <div className='w-6 rounded-l-s bg-system-notice-050' />
        {/* reservation info */}
        <div className={cn('flex flex-1 justify-between p-5', isSure && 'p-3')}>
          <div
            className={cn(
              'flex flex-col gap-[72px]',
              isSure && 'justify-between gap-0',
            )}
          >
            <div className='flex flex-col gap-1'>
              <p
                className={cn(
                  'text-body2 tracking-l text-grey-030',
                  isSure && 'text-caption1 tracking-xl',
                )}
              >
                {companyName}
              </p>
              <p
                className={cn(
                  'text-header2 tracking-xs text-grey-080',
                  isSure && 'text-sub2',
                )}
              >
                {vehicleModelName}
              </p>
            </div>
            <div className='flex flex-col gap-2'>
              <div className='flex w-fit items-center justify-center rounded-full bg-system-notice-050 px-2 py-1 text-sub5 text-grey-000'>
                {`D-${Dday}`}
              </div>
              <div className='flex flex-col gap-1'>
                {/* rental period */}
                <div className='flex items-center gap-2'>
                  <div className='flex flex-col'>
                    <p className='text-sub4 tracking-m text-grey-080'>
                      {pickUpDate}
                    </p>
                    <p className='text-sub5 tracking-l text-grey-060'>
                      {pickUpTime}
                    </p>
                  </div>
                  <p className='text-sub4 tracking-m text-grey-080'>-</p>
                  <div className='flex flex-col'>
                    <p className='text-sub4 tracking-m text-grey-080'>
                      {dropOffDate}
                    </p>
                    <p className='text-sub5 tracking-l text-grey-060'>
                      {dropOffTime}
                    </p>
                  </div>
                </div>

                {/* reservation id */}
                <p className='text-caption2 tracking-xl text-grey-060'>
                  {reservationId}
                </p>
              </div>
            </div>
          </div>
          <div
            className={cn(
              'flex h-fit rounded-s bg-system-notice-040 px-2 py-1 text-sub3 tracking-m text-grey-080',
              isSure && 'text-sub4',
            )}
          >
            Reserved
          </div>
        </div>

        {/* QR code */}
        {!isSure && (
          <>
            <img src={Divider} alt='divider' />
            <div className='flex flex-col items-center justify-center gap-2 px-3'>
              <QRCode
                value={sureDeepLinkUrl}
                size={120}
                style={{
                  padding: '8px',
                }}
              />
              <div className='flex flex-col items-center'>
                <div className='flex items-center gap-1'>
                  <span className='text-sub5 tracking-l text-grey-050'>
                    Scan to install
                  </span>
                  <div className='flex h-5 w-10 items-center justify-center rounded-s bg-yellow-050'>
                    <img src={SureLogo} alt='sureLogo' width={30} height={14} />
                  </div>
                </div>
                <p className='whitespace-pre-line text-center text-sub5 tracking-l text-grey-050'>{`Your reservation will open\nright after download.`}</p>
              </div>
            </div>
          </>
        )}
      </div>
      <p className='text-caption2 tracking-l text-grey-050'>{time}</p>
    </div>
  );
};

export default ReservationTicket;
